import React, { useState, useEffect } from "react";
import { useGlobalState } from "../contexts/GlobalStateContext";

const UpdateAboutModal = ({ onClose }) => {
  const [newAbout, setNewAbout] = useState("");
  const [charCount, setCharCount] = useState(0);
  const { globalState, logOut, setGlobalState, resetGlobalState } =
    useGlobalState();
  const maxLength = 222;

  useEffect(() => {
    if (!globalState.isAuthenticated) return;
    setNewAbout(globalState.user.aboutMe || "");
    setCharCount((globalState.user.aboutMe || "").length);
  }, [globalState.user.aboutMe, globalState.isAuthenticated]);

  const handleChange = (e) => {
    const value = e.target.value.slice(0, maxLength);
    setNewAbout(value);
    setCharCount(value.length);
  };

  const updateAbout = async () => {
    try {
      const response = await fetch("/php/updateAbout.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ newAbout: newAbout }),
      });

      const result = await response.json();

      if (response.ok) {
        setGlobalState((prev) => ({
          ...prev,
          user: {
            ...prev.user,
            aboutMe: newAbout, // or toTitleCase(newTitle.trim()) if needed
          },
        }));

        onClose();
      } else if (result.status === "error") {
        logOut();
        resetGlobalState();
      } else {
        alert(result.message || "Failed to update. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again.");
    }
  };
  const isMobile =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  return (
    <div id="comments-modal" className="modal" style={{ display: "block" }}>
      <div className="w3-modal" style={{ display: "block" }}>
        <div className="update-title w3-animate-bottom">
          <header className="w3-container w3-teal">
            <div className="toggle_row">
              <div
                className="columnA"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "25px",
                }}
              >
                <span style={{ fontSize: "20px", marginLeft: "5px"  }}>Tell Others About You:</span>
                <span
                  onClick={onClose}
                  style={{
                    fontSize: "40px",
                    cursor: "pointer",
                    marginTop: isMobile ? "-7.5px" : "0px",
                  }}
                >
                  ×
                </span>
              </div>
            </div>
          </header>

          <div className="w3-container" style={{ marginTop: 10 }}>
            <textarea
              class="textarea"
              type="text"
              value={newAbout}
              onChange={handleChange}
              placeholder="Type here..."
              maxLength={maxLength}
            />
            <div style={{ textAlign: "center", marginTop: 5 }}>
              <span
                id="titleCharCount"
                style={{ color: charCount >= maxLength ? "red" : "black" }}
              >
                {charCount}/{maxLength}
              </span>
            </div>
          </div>

          <div className="centered-buttons" style={{ margin: "10px 0" }}>
            <button style={{ backgroundColor: "gray" }} onClick={onClose}>
              Cancel
            </button>
            <button onClick={updateAbout}>Update</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateAboutModal;
